import React from "react";
import ErrorBoundary from "../controls/ErrorBoundary";
import ExtensionGate from "../controls/ExtensionGate";
import { useExtensionObjects } from "../ExtensionProvider";
const registerDialog = (_instanceGroup, id, component, props) => {
    return { id, component, props };
};
const RenderDialog = ({ dialog, visibleDialog, onHideDialog, }) => {
    const props = dialog.props !== undefined ? dialog.props() : {};
    return (React.createElement(ErrorBoundary, { canDisplayError: false, className: "errorboundary-dialog", key: dialog.id, visible: dialog.id === visibleDialog, onHide: onHideDialog },
        React.createElement(ExtensionGate, { id: dialog.id },
            React.createElement(dialog.component, { visible: dialog.id === visibleDialog, onHide: onHideDialog, ...props }))));
};
export const DialogContainer = ({ visibleDialog, onHideDialog, }) => {
    const dialogs = useExtensionObjects(registerDialog);
    return (React.createElement("div", { id: "dialog-container" }, dialogs.map((dialog) => RenderDialog({ dialog, visibleDialog, onHideDialog }))));
};
export default DialogContainer;
